/**
 * 信物详情弹窗
 * */
import React, { Fragment, Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import Util from '../../../script/util';
import { Modal } from 'antd';
import WebglVideo from '../../webglVideo/indexNew';

class TokenDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      detail: null,
    };
  }

  // 展示弹窗
  showModal = (detail) => {
    this.setState({ visible: true, detail });
  };
  // 关闭弹窗
  hideModal = () => {
    this.setState({ visible: false, detail: null }, () => {
      // 销毁高级特效
      if (this.seniorEffectsPlayer?.stopAnimation) {
        this.seniorEffectsPlayer.stopAnimation();
        this.seniorEffectsPlayer.clear();
        this.seniorEffectsPlayer.clearDynamicObjects();
      } else if (this.seniorEffectsPlayer?.stop) {
        this.seniorEffectsPlayer.stop();
      }
      this.seniorEffectsPlayer = null;
      clearTimeout(this.seniorEffectsTime);
    });
  };

  // 处理预览详情展示图片
  renderPropImg = () => {
    const { detail, visible } = this.state;
    let className = 'mall-center';

    const isSeniorEffects =
      detail?.showPic?.indexOf('.svga') > -1 ||
      detail?.showPic?.indexOf('.mp4') > -1 ||
      false;
    if (isSeniorEffects && visible) {
      if (detail?.showPic.indexOf('.svga') > -1) {
        // SVGA 素材单独处理
        if (!window._SVGA) return;
        this.seniorEffectsTime = setTimeout(() => {
          this.seniorEffectsPlayer = new window.SVGA.Player('#propBox');
          this.svgaParser = new window.SVGA.Parser('#propBox');

          // 初始化SVGA
          this.svgaParser.load(
            Util.transImgUrl(detail?.showPic),
            (videoItem) => {
              if (this.state.visible) {
                this.seniorEffectsPlayer.loops = 0; // 播放次数
                this.seniorEffectsPlayer.setVideoItem(videoItem);
                this.seniorEffectsPlayer.startAnimation();
              }
            }
          );
        }, 200);
      } else if (detail?.showPic.indexOf('.mp4') > -1) {
        this.seniorEffectsTime = setTimeout(async () => {
          this.seniorEffectsPlayer = await WebglVideo({
            container: this.propBoxEle,
            src: Util.transImgUrl(detail?.showPic),
            loop: true,
          });
        }, 200);
      }
    }
    return (
      <div className={className}>
        <div
          className="prop-box"
          id="propBox"
          ref={(el) => (this.propBoxEle = el)}
        >
          {!isSeniorEffects ? (
            <img
              src={Util.transImgUrl(detail?.showPic)}
              alt={detail?.name || ''}
            />
          ) : null}
        </div>
      </div>
    );
  };

  // 处理时间单位
  timeUnit = (num, unit) => {
    // 0:天,1:小时,2:个数
    let unitText = '';
    let isForever = false; // 是否永久
    switch (Number(unit)) {
      case 0:
        unitText = '天';
        isForever = num > 365 * 30; // 判断大于30年则永久
        break;
      case 1:
        unitText = '小时';
        break;
      case 2:
        unitText = '个';
        break;
      default:
        unitText = '天';
        break;
    }

    return isForever ? '永久' : `${num}${unitText}`;
  };

  render() {
    const { detail, visible } = this.state;
    return (
      <Modal
        open={visible}
        title="道具预览"
        zIndex={1003}
        onCancel={this.hideModal}
        width={400}
        footer={null}
        centered={true}
        keyboard={false}
        maskClosable={false}
        wrapClassName="daidai-modal-style has-top-border props-preview"
      >
        {detail ? (
          <Fragment>
            <div
              className="preview-img"
              style={{
                backgroundImage: detail?.backgroundPic
                  ? `url(${Util.transImgUrl(detail?.backgroundPic)})`
                  : 'none',
              }}
            >
              {this.renderPropImg()}
              {detail?.rarityConfig ? (
                <div className="rarity">
                  <img
                    src={Util.transImgUrl(detail?.rarityConfig?.labelImg)}
                    alt={detail?.giftName || ''}
                  />
                </div>
              ) : null}
              <div className="masking" />
            </div>

            <div className="preview-desc" style={{ padding: '0 20px 20px' }}>
              <h3 className="name">
                <span>{detail?.giftName}</span>
              </h3>
              <p className="desc">
                {detail?.introduction || <span>&nbsp;&nbsp;&nbsp;</span>}
              </p>
            </div>
          </Fragment>
        ) : null}
      </Modal>
    );
  }
}

export default withRouter(TokenDetailModal, { withRef: true });
